export default __webpack_public_path__ + "static/semicloggedneedlefile-41768b4da32f89defdf2a5835eab6981.png";